import useAuth from "./hooks/useAuth";
import { useEffect, useState } from "react";
import CategoryDropdownDynamic from "./CategoryDropdownDynamic";
import CheckUserPhonemesDynamic from "./CheckUserPhonemesDynamic";
import CheckUserPhonemesSnapshot from "./CheckUserPhonemesSnapshot";

const CheckUserPhonemes = ({language, date, checkuser, representation}) => {
    return (
        <div className="w-full">
            {representation === 'Snapshot' ? (
                <CheckUserPhonemesSnapshot checkuser={checkuser} language={language} date={date}/>
            ) : (
                <CheckUserPhonemesDynamic checkuser={checkuser} language={language} date={date}/>   
            )}
        </div>
    );
}

export default CheckUserPhonemes;